<template>
  <div class="sideview-container">
    <img src="@/assets/parts/UST/man-side.png" class="man" :style="{height: manImgHeight + 'px'}" />
    <div class="side-wall">
      <div class="pj-container" ref="pjBox" :class="{'P2-pj-container': pjImgType === 'P2'}">
        <img :src="require('@/assets/parts/UST/' + pjImgType + '_side_left.png')" class="wall-plate" />
        <div>
          <img :src="require('@/assets/parts/UST/' + pjImgType + '_side_right2.png')" class="projector" ref="projector" />
          <div ref="vArrow" class="v-arrow arrowImg" :class="{pressArrowImg:USTVDragFlag}" @mousedown="onVMouseDown"></div>
          <div ref="hArrow" class="h-arrow arrowImg" :class="{pressArrowImg:UstHDragFlag}" @mousedown="onHMouseDown"></div>
        </div>
        <div class="wall-to-pjfront-arrow" :class="{'P2ArrowTop': pjImgType === 'P2'}">
          <ArrowItem :itemWidth = 'rightArrowLeft' color='#00bfff'></ArrowItem>
        </div>
      </div>
      <div class="screen" :style="{height:borderHeight +'px',top:boardTop +'px', left:screenLeft + 'px'}">
        <img class="touchUnit" :class="{'P1-touchUnit': pjImgType === 'P1'}" v-if="(fingerTouchStatus && FTULocationState) || (fingerTouchStatus && !FTULocationState && touchInstall)" :style="{position:'absolute',height:touchUnitHeight + 'px !important',top:touchUnitTop}" :src="require('@/assets/parts/UST/' + fingerUintUrl)"/>
        <div v-if="whiteboardSupport && whiteboardStatus" class="white_board_side" :style="{height:boardStatus.height +'px',width:offsetLength + 'px',top:0 +'px', left:-offsetLength + 'px'}"></div>
      </div>
    </div>
    <div class="ceiling-height">
      <USTItem :title="$t('T_CEILING_HEIGHT')" :value="ceilingHeight" addClass="ceiling-height-color" isCeilingHeight="true"></USTItem>
    </div>
    <div class="wall-to-pjfront">
      <USTItem :title="$t('T_WALL_TO_PJ_DISTANCE')" :value="wallToPJ" addClass="wall-to-pjfront-color"></USTItem>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import USTItem from './USTItem'
import ArrowItem from './USTArrow'

export default {
  components: { USTItem, ArrowItem },
  props: ['manImgHeight', 'screenStatus', 'boardStatus', 'pjImgType', 'wallPlateH'],
  data () {
    return {
      sideViewWidth: 245, // 侧视图投影仪可拖拽范围245px
      defaultWidth: 320, // 侧视图显示区域固定为0.32m
      pjLeft: 0,
      UstHDragFlag: false,
      topOffset: 24
    }
  },
  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'USTPjTop',
      'offset',
      'USTVDragFlag',
      'fingerTouchStatus',
      'FTULocationState',
      'whiteboardStatus',
      'selectedModelData',
      'selectedLensData',
      'throwDistanceChecked',
      'realThrowDistanceChecked',
      'screenSizeChecked',
      'flToB',
      'vLensShiftNow',
      'aspectRatio',
      'screenSize',
      'initScreenSize',
      'ustThrowDisSlidertMax',
      'ustScreenSizeMax',
      'ustLensToFrontPj',
      'floor2bottom',
      'ratioScreenSizeMin',
      'ratioScreenSizeMax',
      'boardStatusTop',
      'FTUB2screenT',
      'FTUHeight',
      'FTUT2screenT',
      'board2screenH',
      'touchInstall',
      'floorFootProjectorChecked'
    ]),
    ...mapGetters(['unitLabel']),
    ceilingHeight () {
      return this.$commonJs.changeUnit(this.houseInfo.roomH, this.graph.unit, false, true)
    },
    pjTopVal: {
      get () {
        return this.USTPjTop - this.topOffset
      },
      set (val) {
        this.SET_USTPJTOP(val + this.topOffset)
      }
    },
    rightArrowLeft () {
      return this.pjLeft
    },
    wallToPJ () {
      let value = this.ProjectorLensSpec.find(item => this.selectedModelData.code === item.code)
      let lx = value.lx > 0 ? value.lx / 10 : value.lx / 10 * (-1)
      this.SET_USTLENSTOFRONTPJ(lx)
      return this.$commonJs.changeUnit(this.graph.pjY - lx + this.offset, this.graph.unit, false, true)
    },
    fingerUintUrl () {
      let name = '120mm'
      let url = ''
      let pjImgType = (this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') ? 'P2' : 'P1'
      if (pjImgType === 'P2') {
        if (this.aspectRatio === '16:6' || this.aspectRatio === '21:9') {
          name = '60mm'
        } else {
          name = '46mm'
        }
      }
      url = pjImgType + '_side_foot_' + name + '.png'
      return url
    },
    lightOffset () {
      return this.pjImgType === 'P1' ? 94 : 98
    },
    offsetLength () {
      return this.offset * this.sideViewWidth / this.defaultWidth
    },
    screenLeft () {
      return this.offsetLength + 30
    },
    whiteboardSupport () {
      if (this.selectedModelData.whiteboardSupport) {
        return true
      } else {
        return false
      }
    },
    borderHeight () {
      if (this.whiteboardSupport && this.whiteboardStatus) {
        return this.boardStatus.height
      } else {
        return this.screenStatus.height
      }
    },
    boardTop () {
      if (this.whiteboardSupport && this.whiteboardStatus) {
        return this.boardStatusTop * this.$parent.ceilingHFixed / this.houseInfo.roomH
      } else {
        return this.screenStatus.top
      }
    },
    touchUnitHeight () {
      if (this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') {
        return this.FTUHeight * this.$parent.ceilingHFixed / this.houseInfo.roomH
      }
    },
    touchUnitTop () {
      if (this.FTULocationState && this.screenStatus.top) {
        return (this.screenStatus.top - this.boardTop - this.touchUnitHeight - this.FTUB2screenT) + 'px !important'
      } else {
        return '-' + this.touchUnitHeight + 'px !important'
      }
    },
    screenBottom2board () {
      return this.graph.boardH - this.graph.scrnH - (this.screenStatus.top * this.houseInfo.roomH / this.$parent.ceilingHFixed - this.boardStatusTop)
    }
  },
  methods: {
    ...mapMutations(['SET_USTPJTOP', 'PJZ', 'PJY', 'SCREENSIZE', 'SCRNW', 'SCRNH', 'SET_USTVDRAGFLAG', 'SET_USTLENSTOFRONTPJ', 'SET_VLENSSHIFT', 'VLENSSHIFT', 'SET_TEMVLENSSHIFT']),
    onVMouseDown (e) {
      // event的兼容性
      let ev = e || event

      // 获取鼠标按下的坐标
      let oldY = ev.clientY
      // 获取元素的top值
      this.SET_USTVDRAGFLAG(true)
      let PJTop = this.$refs['pjBox'].offsetTop
      let boardTop = this.boardStatusTop * this.$parent.ceilingHFixed / this.houseInfo.roomH
      let screenTop = this.screenStatus.top

      document.onmousemove = ev => {
        if ((this.throwDistanceChecked || this.floorFootProjectorChecked) && (!this.whiteboardSupport || !this.whiteboardStatus || (this.fingerTouchStatus && !this.FTULocationState))) return
        // event的兼容性
        let e = ev || event
        // 获取鼠标移动时的坐标
        let newY = e.clientY
        // 计算出鼠标的Y方向移动距离
        let moveY = newY - oldY
        if (this.throwDistanceChecked || this.floorFootProjectorChecked) {
          let fixedTop = this.fingerTouchStatus ? this.FTUT2screenT : this.board2screenH
          let moveLimitMin = -(screenTop - boardTop - fixedTop * this.$parent.ceilingHFixed / this.houseInfo.roomH)
          let moveLimitMax = boardTop + this.boardStatus.height - screenTop - this.screenStatus.height - this.board2screenH * this.$parent.ceilingHFixed / this.houseInfo.roomH
          moveY = this.$commonJs.checkRange(moveY, moveLimitMin, moveLimitMax)
        }
        let top = moveY + PJTop + this.topOffset
        let pjzVal = (top * this.houseInfo.roomH) / this.$parent.ceilingHFixed + this.selectedModelData.wallHeight / 10 - this.selectedLensData.mpts2wallBottomHeight + this.selectedLensData.lens2mptsHeight
        this.PJZ(pjzVal)
      }
      // 清除
      document.onmouseup = ev => {
        this.SET_USTVDRAGFLAG(false)
        document.onmousemove = null
      }
    },
    onHMouseDown (e) {
      let ev = e || event
      let oldX = ev.clientX
      let projectorLeft = this.$refs['projector'].offsetLeft + this.lightOffset
      let minDis = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin) + this.offset
      let maxDis = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMax) + this.offset
      this.UstHDragFlag = true
      document.onmousemove = ev => {
        if (this.realThrowDistanceChecked) return
        let e = ev || event
        let newX = e.clientX
        let moveX = newX - oldX
        let pjLeft = moveX + projectorLeft

        let screenToLens = (pjLeft * this.defaultWidth) / this.sideViewWidth
        let throwDisSliderw = this.$commonViewJs.getKy()
        let throwDisSlidert = this.$commonViewJs.getLy()
        if (this.ustThrowDisSlidertMax) {
          throwDisSlidert = this.ustThrowDisSlidertMax + this.ustLensToFrontPj + this.offset
          if (throwDisSliderw > throwDisSlidert) throwDisSlidert = throwDisSliderw
        } else if (this.ustScreenSizeMax) {
          throwDisSlidert = this.$commonViewJs.calScreensizeToDistanceWide(this.ustScreenSizeMax) + this.offset
          maxDis = maxDis > throwDisSlidert ? throwDisSlidert : maxDis
        }
        if (screenToLens <= minDis) {
          screenToLens = minDis
          pjLeft = screenToLens * this.sideViewWidth / this.defaultWidth
        } else if (screenToLens >= maxDis + (this.screenSizeChecked ? throwDisSlidert - throwDisSliderw : 0)) {
          screenToLens = maxDis + (this.screenSizeChecked ? throwDisSlidert - throwDisSliderw : 0)
          pjLeft = screenToLens * this.sideViewWidth / this.defaultWidth
        }
        if (this.screenSizeChecked) {
          if (screenToLens < throwDisSliderw) {
            screenToLens = throwDisSliderw
          }
          if (screenToLens > throwDisSlidert) {
            screenToLens = throwDisSlidert
          }
          this.PJY(screenToLens - this.offset)
          this.checkIsElectron()
        } else {
          this.PJY(screenToLens - this.offset)
          let screen = this.$commonViewJs.getScreenXyFromDist(screenToLens - this.offset)
          this.SCRNW(screen.calX)
          this.SCRNH(screen.calY)
          if (this.throwDistanceChecked) {
            this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(screenToLens - this.offset))
            let flToB = this.whiteboardSupport && this.whiteboardStatus ? this.floor2bottom + this.screenBottom2board : this.flToB
            this.PJZ(this.houseInfo.roomH - (flToB + screen.calY / 2 - screen.calY * this.vLensShiftNow / 100))
          }
        }
      }

      // 清除
      document.onmouseup = ev => {
        this.UstHDragFlag = false
        document.onmousemove = null
      }
    },
    checkIsElectron () {
      let flag = -1
      let vlensShiftN
      let selectedLensData = this.selectedLensData
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, selectedLensData)
      if (this.screenSizeChecked) {
        let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
        let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        let v1b = wSizeInch * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let l = (wSize.calY - this.graph.scrnH) / 2
        vlensShiftN = (wSize.calY / 2 + v1b - selectedLensData.mu - l) / this.initScreenSize.h * flag
      } else {
        let v1b = this.screenSize * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        vlensShiftN = (this.graph.scrnH / 2 + v1b - selectedLensData.mu) / this.initScreenSize.h * flag
      }

      if (vlensShiftN) {
        this.SET_VLENSSHIFT(vlensShiftN * 100)
        let vals = {}
        vals.max = vlensShiftN
        vals.min = vlensShiftN
        this.VLENSSHIFT(vals)
        let ll = {}
        ll.max = vlensShiftN * flag
        ll.min = vlensShiftN * flag
        this.SET_TEMVLENSSHIFT(ll)
      }
      if (this.screenSizeChecked && this.throwDistanceChecked) {
        this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * vlensShiftN))
      }
    },
    setPosition () {
      this.pjLeft = ((this.graph.pjY + this.offset) * this.sideViewWidth) / this.defaultWidth
      this.$refs['pjBox'].style.top = this.pjTopVal + 'px'
      this.$refs['projector'].style.left = this.pjLeft - this.lightOffset + 'px'
      this.$refs['hArrow'].style.left = this.pjLeft + 60 + 'px'
    }
  }
}
</script>
<style scoped>
.ceiling-height {
  position: relative;
  bottom: 300px;
  left: 140px;
}
.wall-to-pjfront {
  position: absolute;
  left: 74px;
  bottom: 142px;
}
.side-wall {
  position: absolute;
  width: 295px;
  height: 600px;
  top: 120px;
  left: 0px;
  /* background: pink; */
}
.pj-container {
  width: auto;
  height: 80px;
  position: absolute;
  top: 220px;
  left: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.P2-pj-container {
  left: 29px;
}
.pj-container img {
  position: absolute;
}
.wall-plate {
  z-index: 10;
}
.man {
  position: absolute;
  bottom: 100px;
  left: 90px;
}
.screen {
  position: relative;
  top: 400px;
  width: 40px;
  height: 285px;
  background: url("../../../assets/parts/UST/screen_side.png") no-repeat;
  background-size: cover;
}
.white_board_side {
  border: 1px solid black;
  position: relative;
  background-color: #e3e3e3;
}
.arrowImg {
  width: 34px;
  height: 95px;
  background: url("../../../assets/parts/UST/btn_move.png") no-repeat;
}
.arrowImg:hover {
  cursor:pointer;
  background: url("../../../assets/parts/UST/btn_move_hover.png") no-repeat;
}
.pressArrowImg {
  cursor:pointer;
  background: url("../../../assets/parts/UST/btn_move_hover.png") no-repeat;
}
.v-arrow {
  position: absolute;
  left: 195px;
  top: 20px;
}
.h-arrow {
  position: absolute;
  left: 120px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  top: 60px;
}
.wall-to-pjfront-arrow{
  position: absolute;
  left: 17px;
  top: 54px;
  z-index: 20;
}
.wall-to-pjfront-arrow.P2ArrowTop{
  top: 44px;
}
.touchUnit {
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/graph/UST/USTSideView.vue